"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAIInterestRateModelV3Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "jumpMultiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "kink_",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "pot_",
                type: "address",
            },
            {
                internalType: "address",
                name: "jug_",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner_",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "baseRatePerBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplierPerBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "jumpMultiplierPerBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "kink",
                type: "uint256",
            },
        ],
        name: "NewInterestParams",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "assumedOneMinusReserveFactorMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "baseRatePerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "blocksPerYear",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "dsrPerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "gapPerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "getBorrowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserveFactorMantissa",
                type: "uint256",
            },
        ],
        name: "getSupplyRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isInterestRateModel",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "jumpMultiplierPerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "kink",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "multiplierPerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "poke",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "baseRatePerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "gapPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "jumpMultiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "kink_",
                type: "uint256",
            },
        ],
        name: "updateJumpRateModel",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "utilizationRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x60806040523480156200001157600080fd5b506040516200129338038062001293833981810160405260a08110156200003757600080fd5b508051602082015160408301516060840151608090940151600080546001600160a01b0319166001600160a01b038316178155939492939192918086868483808484846200008884808585620000f8565b5050505050505050505062503340668e1bc9bf04000081620000a657fe5b04600555600680546001600160a01b038086166001600160a01b0319928316179092556007805492851692909116919091179055620000ed6001600160e01b03620001ea16565b505050505062000777565b6200011562503340856200046660201b6200081e1790919060201c565b6002556200016d620001376250334083620004b9602090811b620007c517901c565b62000159670de0b6b3a764000086620004b960201b620007c51790919060201c565b6200046660201b6200081e1790919060201c565b6001556200018b826250334062000466602090811b6200081e17901c565b60038190556004829055600254600154604080519283526020830191909152818101929092526060810183905290517f6960ab234c7ef4b0c9197100f5393cfcde7c453ac910a27bd2000aa1dd4c068d9181900360800190a150505050565b60075460408051636cb1c69b60e11b8152644554482d4160d81b600482015281516000936001600160a01b03169263d9638d369260248082019391829003018186803b1580156200023a57600080fd5b505afa1580156200024f573d6000803e3d6000fd5b505050506040513d60408110156200026657600080fd5b505160075460408051635001f3b560e01b815290519293506000926200035192600f926200033d926b033b2e3c9fd0803ce8000000926200015992670de0b6b3a7640000928692869262000329926001600160a01b0390921691635001f3b591600480820192602092909190829003018186803b158015620002e757600080fd5b505afa158015620002fc573d6000803e3d6000fd5b505050506040513d60208110156200031357600080fd5b50518b9062000517602090811b6200072217901c565b6200057260201b620007831790919060201c565b620004b960201b620007c51790919060201c565b905062000380670d2f13f7789f000062000159670de0b6b3a76400006200033d6001600160e01b03620005bc16565b6002819055811115620003e157620003d860045462000159670de0b6b3a76400006200033d600554620003c4600254886200057260201b620007831790919060201c565b6200051760201b620007221790919060201c565b60015562000410565b6200040c60045462000159670de0b6b3a7640000600554620004b960201b620007c51790919060201c565b6001555b600254600154600354600454604080519485526020850193909352838301919091526060830152517f6960ab234c7ef4b0c9197100f5393cfcde7c453ac910a27bd2000aa1dd4c068d9181900360800190a15050565b6000620004b083836040518060400160405280601a81526020017f536166654d6174683a206469766973696f6e206279207a65726f0000000000008152506200067360201b60201c565b90505b92915050565b600082620004ca57506000620004b3565b82820282848281620004d857fe5b0414620004b05760405162461bcd60e51b8152600401808060200182810382526021815260200180620012726021913960400191505060405180910390fd5b600082820183811015620004b0576040805162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604482015290519081900360640190fd5b6000620004b083836040518060400160405280601f81526020017f536166654d6174683a207375627472616374696f6e20756e646572666c6f77008152506200071a60201b60201c565b60006200066e600f6200033d633b9aca00620001596b033b2e3c9fd0803ce8000000600660009054906101000a90046001600160a01b03166001600160a01b031663487bf0826040518163ffffffff1660e01b815260040160206040518083038186803b1580156200062d57600080fd5b505afa15801562000642573d6000803e3d6000fd5b505050506040513d60208110156200065957600080fd5b50519062000572602090811b6200078317901c565b905090565b60008183620007035760405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b83811015620006c7578181015183820152602001620006ad565b50505050905090810190601f168015620006f55780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b5060008385816200071057fe5b0495945050505050565b600081848411156200076f5760405162461bcd60e51b8152602060048201818152835160248401528351909283926044909101919085019080838360008315620006c7578181015183820152602001620006ad565b505050900390565b610aeb80620007876000396000f3fe608060405234801561001057600080fd5b50600436106100c55760003560e01c806315f24053146100ca57806318178358146101055780632037f3e71461010f5780632191f92a1461013e5780636dac7cd51461015a5780636e71e2d8146101625780638726bb891461018b5780638da5cb5b1461019357806396456c5c146101b7578063a385fb96146101bf578063b8168816146101c7578063b9f9850a146101f6578063f14039de146101fe578063f52d21f314610206578063fd2da3391461020e575b600080fd5b6100f3600480360360608110156100e057600080fd5b5080359060208101359060400135610216565b60408051918252519081900360200190f35b61010d61022d565b005b61010d6004803603608081101561012557600080fd5b5080359060208101359060408101359060600135610458565b6101466104c5565b604080519115158252519081900360200190f35b6100f36104ca565b6100f36004803603606081101561017857600080fd5b50803590602081013590604001356104d6565b6100f3610514565b61019b61051a565b604080516001600160a01b039092168252519081900360200190f35b6100f3610529565b6100f36105d2565b6100f3600480360360808110156101dd57600080fd5b50803590602081013590604081013590606001356105d9565b6100f361064d565b6100f3610653565b6100f3610659565b6100f361065f565b6000610223848484610665565b90505b9392505050565b60075460408051636cb1c69b60e11b8152644554482d4160d81b600482015281516000936001600160a01b03169263d9638d369260248082019391829003018186803b15801561027c57600080fd5b505afa158015610290573d6000803e3d6000fd5b505050506040513d60408110156102a657600080fd5b505160075460408051635001f3b560e01b8152905192935060009261037e92600f9261036692676765c793fa10079d601b1b9261037292670de0b6b3a7640000928692869261035a926001600160a01b0390921691635001f3b591600480820192602092909190829003018186803b15801561032157600080fd5b505afa158015610335573d6000803e3d6000fd5b505050506040513d602081101561034b57600080fd5b50518b9063ffffffff61072216565b9063ffffffff61078316565b9063ffffffff6107c516565b9063ffffffff61081e16565b90506103a0670d2f13f7789f0000610372670de0b6b3a7640000610366610529565b60028190558111156103ed576103e5600454610372670de0b6b3a76400006103666005546103d96002548861078390919063ffffffff16565b9063ffffffff61072216565b600155610414565b610410600454610372670de0b6b3a76400006005546107c590919063ffffffff16565b6001555b60025460015460035460045460408051948552602085019390935283830191909152606083015251600080516020610a508339815191529181900360800190a15050565b6000546001600160a01b031633146104a15760405162461bcd60e51b8152600401808060200182810382526026815260200180610a916026913960400191505060405180910390fd5b6250334083046005556104b7600080848461085d565b6104bf61022d565b50505050565b600181565b670d2f13f7789f000081565b6000826104e557506000610226565b6102236104fc8361035a878763ffffffff61072216565b61037285670de0b6b3a764000063ffffffff6107c516565b60015481565b6000546001600160a01b031681565b60006105cd600f610366633b9aca00610372676765c793fa10079d601b1b600660009054906101000a90046001600160a01b03166001600160a01b031663487bf0826040518163ffffffff1660e01b815260040160206040518083038186803b15801561059557600080fd5b505afa1580156105a9573d6000803e3d6000fd5b505050506040513d60208110156105bf57600080fd5b50519063ffffffff61078316565b905090565b6250334081565b6000806105e8868686866108ec565b905060006106008561035a898963ffffffff61072216565b90508061060f57509050610645565b600061062d82610372610620610529565b8b9063ffffffff6107c516565b905061063f818463ffffffff61072216565b93505050505b949350505050565b60035481565b60025481565b60055481565b60045481565b6000806106738585856104d6565b905060045481116106ad576106a56002546103d9670de0b6b3a7640000610372600154866107c590919063ffffffff16565b915050610226565b60006106d86002546103d9670de0b6b3a76400006103726001546004546107c590919063ffffffff16565b905060006106f16004548461078390919063ffffffff16565b9050610718826103d9670de0b6b3a7640000610372600354866107c590919063ffffffff16565b9350505050610226565b60008282018381101561077a576040805162461bcd60e51b815260206004820152601b60248201527a536166654d6174683a206164646974696f6e206f766572666c6f7760281b604482015290519081900360640190fd5b90505b92915050565b600061077a83836040518060400160405280601f81526020017f536166654d6174683a207375627472616374696f6e20756e646572666c6f7700815250610953565b6000826107d45750600061077d565b828202828482816107e157fe5b041461077a5760405162461bcd60e51b8152600401808060200182810382526021815260200180610a706021913960400191505060405180910390fd5b600061077a83836040518060400160405280601a815260200179536166654d6174683a206469766973696f6e206279207a65726f60301b8152506109ea565b610870846250334063ffffffff61081e16565b6002556108896104fc625033408363ffffffff6107c516565b60015561089f826250334063ffffffff61081e16565b6003819055600482905560025460015460408051928352602083019190915281810192909252606081018390529051600080516020610a508339815191529181900360800190a150505050565b600080610907670de0b6b3a76400008463ffffffff61078316565b90506000610916878787610665565b90506000610936670de0b6b3a7640000610372848663ffffffff6107c516565b905061063f670de0b6b3a7640000610372836103668c8c8c6104d6565b600081848411156109e25760405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b838110156109a757818101518382015260200161098f565b50505050905090810190601f1680156109d45780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b505050900390565b60008183610a395760405162461bcd60e51b81526020600482018181528351602484015283519092839260449091019190850190808383600083156109a757818101518382015260200161098f565b506000838581610a4557fe5b049594505050505056fe6960ab234c7ef4b0c9197100f5393cfcde7c453ac910a27bd2000aa1dd4c068d536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f776f6e6c7920746865206f776e6572206d61792063616c6c20746869732066756e6374696f6e2ea265627a7a7231582075faa92ea1bfd65de936a171c40e428c166b2a8810289db89b348f26fd8c5a9164736f6c63430005100032536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f77";
class DAIInterestRateModelV3Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(jumpMultiplierPerYear, kink_, pot_, jug_, owner_, overrides) {
        return super.deploy(jumpMultiplierPerYear, kink_, pot_, jug_, owner_, overrides || {});
    }
    getDeployTransaction(jumpMultiplierPerYear, kink_, pot_, jug_, owner_, overrides) {
        return super.getDeployTransaction(jumpMultiplierPerYear, kink_, pot_, jug_, owner_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DAIInterestRateModelV3Factory = DAIInterestRateModelV3Factory;
DAIInterestRateModelV3Factory.bytecode = _bytecode;
DAIInterestRateModelV3Factory.abi = _abi;
//# sourceMappingURL=DAIInterestRateModelV3Factory.js.map